module.exports = __webpack_public_path__ + "img/homeworks.7592367d.png";